import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
  FRENCH,
  LoggerPlugin as ModulLoggerPlugin,
  UtilsPlugin,
} from "@ulaval/modul-components";
import "@ulaval/modul-components/lib/modul.min.css";
import msal from "ulaval-modul-auth-msal";
import Vue, { VNode } from "vue";
import winston from "winston";
import { ApplicationInsightsTransport } from "../../shared/src/logger/appInsightsTransport";
import App from "./App.vue";
import IconPlugin from "./plugins/icons";
import creerPluginLangage from "./plugins/langage";
import LoggerPlugin from "./plugins/logger";
import router from "./router";
import store from "./store";
import "./styles/main.scss";

const debug = process.env.NODE_ENV !== "production";

Vue.config.productionTip = debug;
// Ne pas afficher les logs (warnings, erros, infos) de vue
Vue.config.silent = !debug;

Vue.use(ModulLoggerPlugin, {
  hideAll: !debug,
});
Vue.use(UtilsPlugin, {
  i18PluginOptions: {
    curLang: FRENCH,
  },
  propagateVueParserErrors: false,
});
Vue.use(IconPlugin);

// TODO: Tester avec un navigateur en anglais?
const currentLang: string = localStorage.getItem("lang") || FRENCH;
Vue.use(creerPluginLangage(currentLang));

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env["VUE_APP_APP_INSIGHTS_INSTRUMENTATION_KEY"] || "",
  },
});
appInsights.loadAppInsights();

Vue.use(LoggerPlugin, {
  appInsights,
  router,
  baseName: "slc",
  level: debug ? "debug" : "error",
});

Vue.use(msal, {
  auth: {
    clientId: process.env["VUE_APP_MODUL_AUTH_MSAL_CLIENT_ID"] || "",
    redirectUri: process.env["VUE_APP_MODUL_AUTH_MSAL_REDIRECT_URI"] || "",
    postLogoutRedirectUri:
      process.env["VUE_APP_MODUL_AUTH_MSAL_REDIRECT_URI"] || "",
  },
  logger: winston.createLogger({
    transports: [
      new ApplicationInsightsTransport({
        appInsights,
        level: debug ? "debug" : "error",
      }),
    ],
  }),
});

// Gestion globale des erreurs VueJS
Vue.config.errorHandler = (err, vm, info) => {
  vm.$logger.log({
    level: "error",
    message: err.message,
    meta: { error: err.stack, info },
  });
};

new Vue({
  router,
  store,
  render: (h): VNode => h(App),
}).$mount("#app");
